/**
 * Where /go-to-lms lands in the LMS: a plain in-app path such as "/learn" (letters, digits, "/", "-", "_"),
 * never a URL, so the link can't be turned into an open redirect. Anything else goes to the LMS home.
 */
export function lmsDestination(to: string | null): string {
    return to && /^\/[A-Za-z0-9/_-]*$/.test(to) && !to.startsWith("//") ? to : "/dashboard"
}
